var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCtBusinessOrange = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 25,
  viewBox: "0 0 21 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.00001 7C5.00001 6.46957 5.21071 5.96086 5.58579 5.58579C5.96087 5.21072 6.46958 5 7.00001 5H15C15.5304 5 16.0392 5.21072 16.4142 5.58579C16.7893 5.96086 17.0001 6.46957 17.0001 7V19C17.2653 19 17.5196 19.1054 17.7072 19.2929C17.8947 19.4804 18 19.7348 18 20C18 20.2652 17.8947 20.5196 17.7072 20.7071C17.5196 20.8947 17.2653 21 17.0001 21H14.0001C13.7348 21 13.4805 20.8947 13.2929 20.7071C13.1054 20.5196 13 20.2652 13 20V18C13 17.7348 12.8946 17.4804 12.7071 17.2929C12.5196 17.1054 12.2652 17 12 17H10C9.7348 17 9.48044 17.1054 9.29291 17.2929C9.10537 17.4804 9.00001 17.7348 9.00001 18V20C9.00001 20.2652 8.89465 20.5196 8.70712 20.7071C8.51958 20.8947 8.26523 21 8.00001 21H5.00001C4.73479 21 4.48043 20.8947 4.2929 20.7071C4.10535 20.5196 4 20.2652 4 20C4 19.7348 4.10535 19.4804 4.2929 19.2929C4.48043 19.1054 4.73479 19 5.00001 19V7ZM8.00001 8H10V10H8.00001V8ZM10 12H8.00001V14H10V12ZM12 8H14.0001V10H12V8ZM14.0001 12H12V14H14.0001V12Z",
  fill: "#FB8C3D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCtBusinessOrange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ct-business-orange.755b32c81cbadc9ead0be80d3180d475.svg";